import { render } from "./GridColumn.vue?vue&type=template&id=152b0b97&scoped=true"
import script from "./GridColumn.vue?vue&type=script&lang=js"
export * from "./GridColumn.vue?vue&type=script&lang=js"

import "./GridColumn.vue?vue&type=style&index=0&id=152b0b97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152b0b97"]])

export default __exports__